import React from 'react';
import Raven from 'raven-js';
import config from '../../data/config';

Raven.config(config.sentry.dsn).install();

export class Sentry extends React.Component {

    state = {
        error: null
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error });

        if (config.sentry.enabled) {
            Raven.captureException(error, { extra: errorInfo });
        }
    }

    render() {
        return this.props.children;
    }
}
